<style lang="less" rel="stylesheet/less" scoped>
    .list{
        /*padding:20px 0;*/
    }
    .more,.no-more,.loading{
        text-align:center;
    }
</style>
<template>
    <div class="list" ref="wrapper">
        <PullReload :onReload="onReload">
            <div style="height:20px;"></div>
            <ArticleListItem :item="item" v-for="item in list"></ArticleListItem>
            <div class="loading" v-if="loading && !pullLoading">正在加载...</div>
            <div class="more" v-if="!loading && list.length && !inTheEnd" @click="loadMore();">更多...</div>
            <div class="more" v-if="!loading && list.length && inTheEnd" >- 没有更多啦 -</div>
            <div class="no-more" v-if="!loading && !list.length"> Oh-oh! 这里还没有数据哦 <br> 快去发布吧</div>
            <div class="iphone-x-block"></div>
            <div style="height:80px;"></div>
        </PullReload>
        <BottomBar></BottomBar>
    </div>
</template>
<script type="text/ecmascript-6">
    import ArticleListItem from '../components/ArticleListItem.vue';
    import BottomBar from '../components/BottomBar';
    import PullReload from '../components/PullReload';
    import api from '../lib/api';

    export default {
        data() {
            return {
                inTheEnd:false,
                loading:false,
                pullLoading:false,
                list:[],
                page:0,
                query:{
                    keyword:'',
                    keywordBackup:'',
                }
            }
        },
        watch:{
            '$route':function (newRoute,oldRoute) {
                if( oldRoute.name ==='news' && this.queryIsSame(newRoute.query,oldRoute.query) &&  typeof newRoute.query.page !== 'undefined' ){
                    return;
                }
                this.init();
            }
        },
        beforeRouteLeave(to,from,next){
            if(to.name==='news-detail'){
                window._index_scrollTop = $('html').scrollTop()||$('body').scrollTop();
            }else{
                window._index_scrollTop = 0;
            }
            next();
        },
        computed: {},
        methods: {
            queryIsSame(q1,q2){
                var same = true;
                Object.keys(this.$options.data().query).forEach(k=>{
                    if(q1[k]!==q2[k]){
                        same =false;
                    }
                });
                return same;
            },
            setScrollTop(n){
                console.log('set top',n);
                $('html').scrollTop(n);
                $('body').scrollTop(n);
            },
            init(firstTime){
                let query = this.$route.query;
                console.log(query);
                $.extend(this,this.$options.data());
                $.extend(this.query,query);
                this.query.keywordBackup = this.query.keyword;
                this.setScrollTop(0);
                let option = {};
                if(firstTime && query.page){
                    option.initPage = query.page;
                }
                this.load(option).then(()=>{
                    if(firstTime && query.page && window._index_scrollTop){
                        this.$nextTick(()=>{
                            this.setScrollTop( window._index_scrollTop );
                            window._index_scrollTop = 0;
                        })
                    }else{
                        this.setScrollTop(0);
                    }
                });
            },
            goSearchWithQuery(){
                this.$router.push({
                    name:'news',
                    query:{
                        topicId:this.query.topicId,
                        categoryId:this.query.categoryId,
                        keyword:this.query.keywordBackup,
                        t:+new Date()
                    }
                });
            },
            recordPage(){
                this.$router.replace({
                    name:'news',
                    query:{
                        topicId:this.query.topicId,
                        categoryId:this.query.categoryId,
                        keyword:this.query.keywordBackup,
                        t:+new Date(),
                        page:this.page
                    }
                })
            },
            onCategoryChange({categoryId,topicId}){
                this.query.topicId = topicId||'';
                this.query.categoryId = categoryId;
                this.query.keywordBackup = '';
                this.query.keyword = '';
                // this.page = 0;
                // this.list = [];
                // this.inTheEnd = false;
                // this.load();
                this.goSearchWithQuery();
            },
            onSearch(value){
                this.query.keywordBackup = value;
                this.query.keyword = value;
                this.query.categoryId = '';
                this.query.topicId = '';
                this.goSearchWithQuery();
                // this.page = 0;
                // this.inTheEnd = false;
                // this.list = [];
                // this.load();
            },
            onReload(){
                this.page = 0;
                this.inTheEnd = false;
                this.pullLoading = true;
                return this.load({isPullLoading:true}).then(()=>{
                    this.pullLoading = false;
                });
            },
            onMenu(item){
                this.$refs.menu.open(item);
            },
            onItemClick(item){
                this.$router.push({name:'detail',query:{id:item.id}})
            },
            loadMore(){
                if(!this.inTheEnd && !this.loading){
                    this.page++;
                    this.load();
                }
            },
            showOverlay(){
                if(this && this.$refs && this.$refs.cate && this.$refs.cate.menuActive){
                    return true;
                }
                return false;
            },
            clickOverlay(){
                if(this && this.$refs && this.$refs.cate ){
                    this.$refs.cate.hideMenu();
                }
            },
            onScroll(){
                if(!this.loading && !this.list.length) return;
                var h = 200;
                var a = $(window).scrollTop();
                var b = $(window).height();
                var c = $(this.$refs.wrapper).height();
                if(c-(a+b)<=h  && !this.loading){
                    this.loadMore();
                }
            },
            load(options={}){
                this.loading = true;
                let initPage = Number(options.initPage);
                let page = this.page;
                let size = 10;
                if(initPage){
                    page = 0;
                    size = 10*(initPage+1);
                    this.page = initPage;
                }
                return api.getArticleList({
                    tag:this.query.keywordBackup,
                    page,
                    size
                }).then(data=>{
                    if(options.isPullLoading){
                        this.list = [];
                    }
                    this.recordPage();
                    this.loading = false;
                    // this.inTheEnd = data.currentPage === (data.maxPage-1);
                    this.list = this.list.concat(data.list||[]);
                }).catch(e=>{
                    this.loading = false;
                })
            },
        },
        components: {
            ArticleListItem,
            BottomBar,
            PullReload
        },
        mounted() {
            this.init(true);

            $(window).off('scroll').on('scroll',()=>{
                this.onScroll();
            });
        }
    }
</script>


// WEBPACK FOOTER //
// article-list.vue?52b51426